import { object, string } from 'yup'
import { CallResponse } from './calls.types'

export const ContactSchema = object().shape({
  firstName: string().min(1).required(),
  lastName: string().min(2).required(),
  contactType: string().oneOf(['SYSTEM', 'CUSTOMER', 'TOWDEST', 'DRIVER', 'FACILITY']).required(),
})

export const CallResponseSchema = object<CallResponse>().shape({
  callKey: string().required(),
})
